import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import SEOSchema from 'cards/components/CardListing/Breadcrumbs/SEOSchema';
import { BreadcrumbsV2 } from '@zola/zola-ui/src/components/BreadcrumbsV2';
import getEnvironment from '@zola-helpers/server/dist/es/environment';
import { getUserContext } from 'selectors/user/userSelectors';
import { SETTINGS_BY_CARD_TYPE } from 'cards/constants/CardTypes';
import { useResponsiveContext } from 'components/common/ResponsiveContext';

const envHostname = () => {
  const env = getEnvironment();
  switch (env) {
    case 'production':
      return 'https://www.zola.com';

    case 'staging':
    case 'development':
    default:
      return 'https://qa.zola.com';
  }
};

const ALL_PLP_TYPES = {
  ...SETTINGS_BY_CARD_TYPE,
  MATCHING_SUITES: {
    label: 'Matching suites',
  },
};

const Breadcrumbs = ({ currentCardType, className = '' }) => {
  const { isMobile } = useResponsiveContext();
  const userContext = useSelector(getUserContext);
  const currentLabel = ALL_PLP_TYPES[currentCardType].label;
  const landingPageUrl = userContext.is_guest
    ? '/wedding-planning/paper'
    : '/wedding-planning/universal';
  const BREADCRUMB_ITEMS = [
    {
      to: landingPageUrl,
      label: 'Invites and paper',
      schemaTo: `${envHostname()}${landingPageUrl}`,
    },
  ];

  return (
    <Fragment>
      <SEOSchema items={BREADCRUMB_ITEMS} currentItem={currentLabel} />
      <BreadcrumbsV2
        className={className}
        disableBackLink={!isMobile}
        linkItems={BREADCRUMB_ITEMS}
        currentSelectionLabel={currentLabel}
      />
    </Fragment>
  );
};

export default Breadcrumbs;
